export function normalizeBackendUrl(raw) {
  let target = String(raw || "https://api.openpipeclub.com").trim();
  target = target.replace(/^\/+/, "");
  if (!target) {
    target = "https://api.openpipeclub.com";
  } else if (!/^https?:\/\//i.test(target)) {
    const isLocal = /^(localhost|127\.0\.0\.1|192\.168\.|10\.)/i.test(target);
    target = `${isLocal ? "http" : "https"}://${target}`;
  }
  if (typeof window !== "undefined" && window.location.protocol === "https:") {
    target = target.replace(/^http:\/\//i, "https://");
  } else {
    target = target.replace(/^http:\/\/api\.openpipeclub\.com/i, "https://api.openpipeclub.com");
  }
  return target.replace(/\/+$/, "").replace(/\/api$/i, "");
}

export const BACKEND_URL = normalizeBackendUrl(process.env.REACT_APP_BACKEND_URL);
export const API = `${BACKEND_URL}/api`;
